import React, { useEffect, useCallback, useState, useMemo } from 'react';
import AppLayout from '../../component/appLayout';
import { getAllRecurringTasks } from '../../services/taskServices';
import TasksDataV2 from '../../component/tasks';
import { captureException } from '../../services/logService';
import { isEmpty } from '../../helpers/common';
import { rootStore } from '../../mobx/rootStore';
import { MobxMyTaskModelInterface } from '../../interfaces/TaskInterface';
import { observer } from 'mobx-react-lite';

const Recurring: React.FC = () => {
  // States
  const [loading, setLoading] = useState(false);

  //use selector state variables
  const { taskStore } = rootStore;
  const { recurringTasks } = taskStore;

  //Mobx store variables
  const { workspaceStore } = rootStore;
  const { currentWorkspace: workspace } = workspaceStore;
  const loadData = useCallback(async () => {
    try {
      if (!isEmpty(workspace?.id)) {
        setLoading(true);
        await getAllRecurringTasks();
      }
    } catch (e) {
      captureException(e);
    } finally {
      setLoading(false);
    }
  }, [workspace?.id]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  // ✅ Derived data computed during render (no setState, no useEffect)
  const data = useMemo<MobxMyTaskModelInterface[]>(() => {
    if (!Array.isArray(recurringTasks)) return [];

    return recurringTasks.reduce((acc: MobxMyTaskModelInterface[], task) => {
      let group = acc.find((g) => g.project_id === task.projectId);

      if (!group) {
        group = {
          project_id: task.projectId,
          title: task?.project?.name || '',
          tasks: []
        };
        acc.push(group);
      }

      group.tasks.push(task);
      return acc;
    }, []);
  }, [recurringTasks]);

  return (
    <AppLayout>
      <TasksDataV2
        key={workspace?.id || ''}
        data={data}
        loading={loading}
        isMyTask={true}
        loadData={loadData}
        isRecurringTask={true}
      />
    </AppLayout>
  );
};

export default observer(Recurring);
